import React, { useState } from "react";
import PropTypes from "prop-types";
import { getApiBaseUrl, LOGIN, ADD_ACTIVITY } from "../../../Config/Config";
import { Modal, Input, Drawer } from "antd";
import Swal from "sweetalert2";

const ReplaceRetireDrawer = ({ selectedAsset, visible, onClose }) => {
  console.log(selectedAsset);
  const [status, setStatus] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [password, setPassword] = useState("");
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const logActivity = async (userId, action, success) => {
    try {
      const activityPayload = {
        ActivityType: 1,
        PerformedBy: userId,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: `Attempted to ${action} filter ${selectedAsset?.Lable}`,
        Location: "Filters List",
        IsSucces: success ? 1 : 0,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(activityPayload),
      });
    } catch (error) {
      console.error("Error logging activity:", error);
    }
  };

  const handlePasswordSubmit = async () => {
    if (!password) {
      Swal.fire({
        icon: "warning",
        title: "Password Required",
        text: "Please enter a password.",
        confirmButtonColor: "#f8bb86",
      });
      return;
    }

    setIsSubmitting(true);
    const user = JSON.parse(sessionStorage.getItem("user"));
    const username = user?.UserID || "admin";
    const UserName = user?.UserName;

    const isReplace = status === "105";
    const action = isReplace ? "Replace" : "Retire";

    try {
      const loginData = { username: UserName, password };
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });
      const loginResult = await loginRes.json();

      await logActivity(username, action, loginResult.status);

      if (!loginResult.status) {
        Swal.fire({
          icon: "error",
          title: "Authentication Failed",
          text: "Invalid password. Operation canceled.",
          confirmButtonColor: "#d33",
        });
        setShowPasswordModal(false);
        onClose();
        setPassword("");
        setIsSubmitting(false);
        return;
      }

      const endpoint = isReplace
        ? "/api/filterReplace"
        : "/api/addFilterRetirement";

      const payload = isReplace
        ? {
            id: selectedAsset?.Id,
            updatedby: username,
            remarks: remarks || "",
          }
        : {
            id: selectedAsset?.Id,
            Status: 105,
            remarks: remarks || "",
            updatedby: username,
          };

      // Step 3: Submit
      const response = await fetch(`${getApiBaseUrl()}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      // Step 4: Handle response
      if (result.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Filter status updated successfully.",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          setShowPasswordModal(false);
          setPassword("");
          setStatus(null);
          setRemarks("");
          onClose();
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result?.message || "Failed to update filter status.",
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while updating the status.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setIsSubmitting(false);
      // window.location.reload();
    }
  };

  const handleSubmit = () => {
    if (!status || !remarks?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Required Fields Missing",
        text: "Please select a status and enter remarks.",
        confirmButtonColor: "#f8bb86",
      });
      return;
    }
    setShowPasswordModal(true);
    onClose();
  };

  return (
    <>
      <Drawer
        title="Replace or Retire Filter"
        placement="right"
        onClose={onClose}
        open={visible}
        width="350"
        className="replace-retire-drawer"
        mask={true}
        extra={
          <>
            <button
              type="submit"
              className="btn btn-sm btn-outline-success me-2"
              title="Update"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              <i className="fa fa-check fs-4"></i>
            </button>
          </>
        }
      >
        {selectedAsset && (
          <div className="row mb-3">
            <div className="col-6">
              <label className="form-label fw-bold">Filter ID</label>
              <input
                type="text"
                className="form-control"
                value={selectedAsset.Lable}
                disabled
              />
            </div>
            <div className="col-6">
              <label className="form-label fw-bold">Current Status</label>
              <input
                type="text"
                className="form-control"
                value={selectedAsset.StageName}
                disabled
              />
            </div>
            <div className="col-6 mt-3">
              <label className="form-label fw-bold">Block</label>
              <input
                type="text"
                className="form-control"
                value={selectedAsset.locatinname}
                disabled
              />
            </div>
          </div>
        )}

        <div className="mb-3">
          <label className="form-label fw-bold">Select Status</label>
          <div className="d-flex flex-column flex-sm-row gap-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                id="statusReplace"
                value="105"
                checked={status === "105"}
                onChange={(e) => setStatus(e.target.value)}
              />
              <label className="form-check-label" htmlFor="statusReplace">
                Replace
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="status"
                id="statusRetire"
                value="104"
                checked={status === "104"}
                onChange={(e) => setStatus(e.target.value)}
              />
              <label className="form-check-label" htmlFor="statusRetire">
                Retire
              </label>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="remarks" className="form-label fw-bold">
            Remarks
          </label>
          <textarea
            className="form-control"
            id="remarks"
            rows="4"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter any remarks..."
          ></textarea>
        </div>
      </Drawer>

      <Modal
        title="Reauthentication Required"
        zIndex={1050}
        open={showPasswordModal}
        getContainer={false}
        onCancel={() => {
          setShowPasswordModal(false);
          onClose();
          setPassword("");
          logActivity(
            JSON.parse(sessionStorage.getItem("user"))?.UserID || "admin",
            status === "105" ? "Replace" : "Retire",
            false
          );
        }}
        footer={[
          <button
            key="cancel"
            className="btn btn-secondary me-2"
            onClick={() => {
              setShowPasswordModal(false);
              onClose();
              setPassword("");
              logActivity(
                JSON.parse(sessionStorage.getItem("user"))?.UserID || "admin",
                status === "105" ? "Replace" : "Retire",
                false
              );
            }}
            disabled={isSubmitting}
          >
            Cancel
          </button>,
          <button
            key="submit"
            className="btn btn-primary"
            onClick={handlePasswordSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>,
        ]}
        centered
        mask={true}
        maskClosable={false}
        keyboard={false}
      >
        <div style={{ marginBottom: "16px" }}>
          <label
            htmlFor="passwordInput"
            style={{ display: "block", marginBottom: "8px" }}
          >
            Password
          </label>
          <Input.Password
            id="passwordInput"
            value={password}
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
            autoComplete="off"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            autoFocus
          />
        </div>
      </Modal>
    </>
  );
};

ReplaceRetireDrawer.propTypes = {
  selectedAsset: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    FilterId: PropTypes.string.isRequired,
    StageName: PropTypes.string.isRequired,
    locatinname: PropTypes.string.isRequired,
    Lable: PropTypes.string.isRequired,
  }),
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ReplaceRetireDrawer;
